import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, type Theme } from 'styles/theme';

export const BylineAndShareWrapper = styled.div<{ isFeatureArticle: boolean; isMobileApp: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (${breakpoint.mdMax}) {
    ${(props) =>
      !props.isMobileApp &&
      css`
        align-items: flex-end;
      `}
  }

  ${(props) =>
    props.isFeatureArticle &&
    css`
      padding: 0 16px;
      justify-content: space-between;

      @media (${breakpoint.mdMin}) {
        padding: 0;
        min-width: 700px;
        margin: 0 auto;
      }
    `}
`;

export const RedesignedHeroBylineWrapper = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' })};
  letter-spacing: 1.2px;
  margin-right: 16px;

`;

export const RedesignedHeroAuthorsContainer = styled.div`
  display: flex;
  gap: 16px;
  text-transform: uppercase;
  margin-bottom: 8px;
  flex-direction: column;
  justify-content: space-around;
`;

export const RedesignedHeroDate = styled.div<{ theme: Theme }>`
  color: ${getColor('textSecondary')};
  letter-spacing: 0;
  min-height: 21px;
`;

export const ShareWrapper = styled.div`
  display: flex;

  @media (${breakpoint.mdMax}) {
    flex-direction: column;
  }

  @media (${breakpoint.mdMin}) {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    place-self: flex-start;
  }
`;

export const GooglePromptWrapper = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  @media (${breakpoint.mdMin}) {
    margin-right: 40px;
  }
`;

export const GooglePromptTitle = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCompact', { default: 'small' }, 'medium')};
  color: ${getColor('accentPrimary')};

  line-height: 140%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;
